import React from "react";
import { Icon } from "../icon";

export const Chevron = (props: {up: boolean}) => {
  return (
    <Icon
      iconId  = {props.up ? "chevronUp" : "chevronDown"}
      cursor  = "pointer"
      size    = "default"
      color   = "white"
    />
  );
}